import { SbbButtonLink, SbbSecondaryButtonLink } from "@sbb-esta/lyne-react/button";
import { defaultButtonSize } from "components/Lyne/LyneConstants";
import { LyneDialog } from "components/Lyne/LyneDialog";
import React, { useEffect } from "react";

export interface ConfirmDialogProps {
  onCancel: () => void;
  onAccept: () => void;
  title: string;
  content: string;
  cancel: string;
  accept: string;
  isOpen: boolean;
  setIsOpen: (newState: boolean) => void;
  isSubmitting?: boolean;
  buttonSize?: "s" | "m" | "l";
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  onAccept,
  onCancel,
  title,
  content,
  cancel,
  accept,
  isOpen,
  setIsOpen,
  isSubmitting,
  buttonSize = defaultButtonSize,
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const handler = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        e.preventDefault();
        if (!isSubmitting) {
          onAccept();
          setIsOpen(false);
        }
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [isOpen, isSubmitting, onAccept, setIsOpen]);

  return (
    <LyneDialog
      isOpen={isOpen}
      title={title}
      content={content}
      actions={
        <>
          <SbbButtonLink
            className="confirm-button"
            iconName="tick-medium"
            size={buttonSize}
            disabled={isSubmitting}
            onClick={async () => {
              onAccept();
              setIsOpen(false);
            }}
          >
            {accept}
          </SbbButtonLink>

          <SbbSecondaryButtonLink
            className="cancel-button"
            size={buttonSize}
            iconName="cross-medium"
            disabled={isSubmitting}
            onClick={async () => {
              onCancel();
              setIsOpen(false);
            }}
          >
            {cancel}
          </SbbSecondaryButtonLink>
        </>
      }
    />
  );
};
